import { useHistory } from 'react-router-dom';
import { Alert } from 'foundations-components/transitional/components/Alert';
import styled from 'styled-components';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledContainer = styled.div.withConfig({
  displayName: "LegacyLoginLink__StyledContainer",
  componentId: "sc-6zarp9-0"
})(["max-width:1100px;"]);
export default function LegacyLoginLink() {
  const history = useHistory();
  const legacyLink = `/legacy${window.location.search}${window.location.hash}`;
  const handleClick = () => {
    history.push(legacyLink);
  };
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    justify: "center",
    direction: "column",
    children: /*#__PURE__*/_jsx(StyledContainer, {
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: I18n.text('login.smartLogin.betaBanner.titleNew'),
        type: "tip",
        use: "inline",
        marginBlockEnd: "400",
        marginBlockStart: "0",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "login.smartLogin.betaBanner.descriptionNew_jsx",
          options: {
            onClick: handleClick,
            size: 'extra-small'
          },
          elements: {
            Link
          }
        })
      })
    })
  });
}